// extracted by mini-css-extract-plugin
module.exports = {"name":"TaskStatusesTable_name__2yTOE","colorStatus":"TaskStatusesTable_colorStatus__2s7Qi"};